import { render, staticRenderFns } from "./MassAssignmentNames.vue?vue&type=template&id=3cdcaddc"
import script from "./MassAssignmentNames.vue?vue&type=script&lang=js"
export * from "./MassAssignmentNames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports